export const PRODUCTION_HOSTNAME = 'capital-clues.web.app';

const isLocalDevHostname = (hostname) => {
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return true;
  }

  // Expo dev loads the web app from the machine's LAN IP, not localhost.
  if (/^192\.168\.\d+\.\d+$/.test(hostname)) return true;
  if (/^10\.\d+\.\d+\.\d+$/.test(hostname)) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d+\.\d+$/.test(hostname)) return true;

  return false;
};

/** 'prod' | 'dev' — single source of truth for environment-specific behavior */
export const env = (() => {
  const hostname = window.location.hostname;

  if (hostname === PRODUCTION_HOSTNAME) {
    return 'prod';
  }

  if (isLocalDevHostname(hostname) || process.env.NODE_ENV === 'development') {
    return 'dev';
  }

  return 'prod';
})();

export const isProd = env === 'prod';
export const isDev = env === 'dev';
